<template>
  <div
    v-if="!hasQuestSubscribe"
    class="news-subscribe-link"
    @click="subscriptionsModalVisible = true"
  >
    <span class="news-subscribe-link__text">Рассылка про карьеру в IT</span>
    <NewsSubscribe
      v-show="subscriptionsModalVisible"
      :show-subscribe="showSubscribe"
      is-modal
      @closeModal="subscriptionsModalVisible = false"
    />
  </div>
</template>

<script>
import { getCookie } from 'src/utils/cookies.js';

import NewsSubscribe from 'src/components/NewsSubscribe/NewsSubscribe.vue';

const NEWS_SUBSCRIBE_FLAG = 'has_news_subscribe';

export default {
  name: 'NewsSubscribeJournal',
  components: { NewsSubscribe },
  data() {
    return {
      subscriptionsModalVisible: false,
      hasQuestSubscribe: true,
    };
  },
  mounted() {
    this.hasQuestSubscribe = getCookie(NEWS_SUBSCRIBE_FLAG);
  },
  methods: {
    showSubscribe({ hasSubscribe }) {
      return !hasSubscribe && this.subscriptionsModalVisible;
    },
  },
};
</script>
